import React, { useRef } from 'react';
import Button from '../Button/Button';
import Input from '../Input/Input';

const File = ({
    name,
    text,
    onChange,
    accept
}) => {
    const fileRef = useRef(null)
    return (
        <div>
            <Button
                onClick={() => fileRef.current.click()}
                text={text}
            />
            <input
                ref={fileRef}
                name={name}
                type="file"
                accept={accept}
                onChange={onChange}
            />

        </div>
    )
};

export default File;
